<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0 costdriversHeader">
        <b-col> </b-col>
        <b-col class="text-right">
          <downloadChart />
        </b-col>
      </b-row>

      <b-row class="m-0 chartTabPanel autoCursor costdriversPanel">
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 1-->
            <b-card header="Annual Analysis" header-tag="header" class="m-2 ">
              <div id="financial_summary_tbl" class="tblWrapper">
                <h5 class="px-2">Income Statement ($ millions)</h5>
                <table>
                  <thead id="financial_summary_head">
                    <th>Category</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="financial_summary_body">
                    <tr
                      v-for="(item, id) in incomestatementTableDataLocal"
                      :key="id"
                    >
                      <td>{{ item["key"] }}</td>
                      <td class="rightAligned">
                        {{ item["2016A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2017A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2018A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2019E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2020E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2021E"] | roundOff }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="key_company_tbl" class="tblWrapper">
                <h5 class="px-2">Cost Assumptions</h5>
                <table>
                  <tbody id="key_company_body">
                    <tr
                      v-for="(cItem, idx) in costassumptionsTableDataLocal"
                      :key="idx"
                    >
                      <td>{{ cItem["key"] }}</td>
                      <td class="rightAligned">
                        {{ cItem["2016A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ cItem["2017A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ cItem["2018A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ cItem["2019E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ cItem["2020E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ cItem["2021E"] | roundOffPer }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <b-card
              header="Cost Assumptions- Scenario Analysis"
              header-tag="header"
              class="m-2 "
            >
              <b-row class="m-0">
                <table class="assumptnTbl">
                  <thead>
                    <tr>
                      <th></th>
                      <th><img :src="sliderFilter" class="sliderIcon" /></th>
                      <th>
                        <h6>
                          Basic
                          <br />
                          Points
                        </h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          General & Administrative
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          @change="sliderValuesChange"
                          v-model="value1"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          @change="sliderValuesChange"
                          v-model="value1"
                          class="ptContainer"
                          id="accruedPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Gross Profit
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          @change="sliderValuesChange"
                          v-model="value2"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          @change="sliderValuesChange"
                          v-model="value2"
                          class="ptContainer"
                          id="apPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          R & D
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          @change="sliderValuesChange"
                          v-model="value3"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          @change="sliderValuesChange"
                          v-model="value3"
                          class="ptContainer"
                          id="capexPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Sales & Marketing
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          @change="sliderValuesChange"
                          v-model="value4"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          @change="sliderValuesChange"
                          v-model="value4"
                          class="ptContainer"
                          id="deferredPt"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Tax Rate
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          @change="sliderValuesChange"
                          v-model="value5"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value5"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="deprPt"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 mb-3">
                  <button @click="resetSliders" class="btn btn-xs btn-primary text-right">
                    Reset
                  </button>
                </div>
              </b-row>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 2-->
            <b-card
              header="Cost Drivers ($ millions)"
              header-tag="header"
              class="m-2 "
            >
              <div class="filterBtn row m-0">
                <div class="filterBtn mx-auto my-2">
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="Operating Expenses"
                    @click="getcostDriverChartData('Operating Expenses')"
                    :class="{'active':filterChartTab=='Operating Expenses'}"
                  >
                    Opt. Exp.
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="Gross Profit"
                    @click="getcostDriverChartData('Gross Profit')"
                    :class="{'active':filterChartTab=='Gross Profit'}"
                  >
                    Gross Profit
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="Operating Income"
                    @click="getcostDriverChartData('Operating Income')"
                    :class="{'active':filterChartTab=='Operating Income'}"
                  >
                    Opt. Income
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="Net Income"
                    @click="getcostDriverChartData('Net Income')"
                    :class="{'active':filterChartTab=='Net Income'}"
                  >
                    Net Income
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="PF EPS"
                    @click="getcostDriverChartData('Adjusted EPS (excl. SBC)')"
                    :class="{'active':filterChartTab=='Adjusted EPS (excl. SBC)'}"
                  >
                    PF EPS
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    name="GAAP EPS"
                    @click="getcostDriverChartData('GAAP EPS')"
                    :class="{'active':filterChartTab=='GAAP EPS'}"
                  >
                    GAAP EPS
                  </button>
                </div>
              </div>
              <div class="chartWrapper" id="keyCompanyChart">
                <Plotly
                  :data="costDriverChartData"
                  :layout="Linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <!--Card 2-->
            <b-card header="Cost Metrics" header-tag="header" class="m-2 ">
              <div class="filterBtn row m-0">
                <div class="filterBtn">
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabCA=='2016A'}"
                    @click="getCostMetricsChartData('2016A')"
                  >
                    2016A
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabCA=='2017A'}"
                    @click="getCostMetricsChartData('2017A')"
                  >
                    2017A
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabCA=='2018A'}"
                    @click="getCostMetricsChartData('2018A')"
                  >
                    2018A
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabCA=='2019E'}"
                    @click="getCostMetricsChartData('2019E')"
                  >
                    2019E
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    @click="getCostMetricsChartData('2020E')"
                    :class="{'active':filterChartTabCA=='2020E'}"
                  >
                    2020E
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabCA=='2021E'}"
                    @click="getCostMetricsChartData('2021E')"
                  >
                    2021E
                  </button>
                </div>
              </div>
              <div class="chartWrapper" id="valuationChart">
                <Plotly
                  :data="costMetricsChartData"
                  :layout="pieLayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
//import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
import sliderFilter from "@/assets/img/sliderImg.png";
export default {
  name: "costdrivers",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      incomestatementmillions: "incomestatementmillions",
      costassumptions: "costassumptions",
      iMost: "iMost",
      isFullScreen: "isFullScreen",
    }),
    iMostChildren() {
      return this.iMost.child;
    },
 
  },
  data() {
    return {
      colorArr: [
        "#C999CA",
        "#FDC381",
        "#C2E587",
        "#FDD7EA",
        "#E1E1E1",
        "#DB704C",
        "#FFA292",
        "#CEDCED",
        "#88B0E2",
        "#D65C33",
      ],
      chartTitle: "",
      sliderValue: [2015, 2020],
      incomestatementTableDataLocal: [],
      costassumptionsTableDataLocal: [],
      filterChartTabCA: null,
      filterChartTab: null,
      min: 2015,
      max: 2020,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      calcCost: false,
      calcAssumption: false,
      sliderFilter: sliderFilter,
      costMetricsChartData: [
        {
          type: "pie",
          values: [],
          labels: [],
          textinfo: "label+value",
          textposition: "outside",
          automargin: true,
          texttemplate:  '%{label}: %{value}%',
          hoverinfo: "label+value",
          hovertemplate: '%{label}: %{value}%',
          ticksuffix: "%",
        },
      ],
      pieLayout: {
        height: 250,
        margin: { t: 50, b: 50, l: "auto", r: "auto" },
        showlegend: false,
      },
      costDriverChartData: [
        {
          name: "",
          type: "bar",
          x: [],
          y: [],
          yaxis: "y",
          marker: { color: "#CCCCCC" },
        },
        {
          name: "YoY % Change",
          type: "line",
          line: {
            shape: 'spline',
            smoothing: 1.3,
            color: "#008000"
          },
          x: [],
          y: [],
          marker: { color: "#008000" },
          yaxis: "y2",
        },
      ],
      Linelayout: {
        width: 620,
        height: 300,
        autosize: true,
        hoverlabel: { bgcolor: "#FFF" },
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
      
          nticks: 8,
        },
        yaxis2: {
          titlefont: { color: "#333" },
          tickfont: { color: "#333" },
          overlaying: "y",
          side: "right",
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          fixedrange: true,
    
          nticks: 5,
        },
        legend: {
          x: 0.2,
          y: -0.3,
          orientation: "h",
        },
      },

      config: { responsive: true },
      GAPoint: 0,
      GPPoint: 0,
      value: 0,
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      value5: 0,
    };
  },
  created() {
    let filterChart = this.iMostChildren.filter(
      (item) => "Cost Drivers" === item.objectname
    );
    // console.log('filterChart-==',filterChart);
    let snapshopChild = filterChart[0].child;
    for (var i = 0; i < snapshopChild.length; i++) {
      this.getChartDataById({
        id: snapshopChild[i].chartId,
        chartName: snapshopChild[i].objectname,
      });
    }
    //  this.getKeyChartData('Sales Growth',"#1f497d");
    this.getcostDriverChartData("Operating Income");
    this.getCostMetricsChartData("2016A");
  },
  methods: {
    ...mapActions(["setDownloadInfo", "getChartDataById"]),
    resetSliders(){
      this.value1 = 0
      this.value2 = 0
      this.value3 = 0
      this.value4 = 0
      this.value5 = 0
      this.sliderValuesChange()
    },
    sliderValuesChange(){
      this.incomestatementTableDataLocal = []
      for(let [idx,i] of this.formatdata(this.incomestatementmillions, "income").entries()){
        if(this.value1){
          if (i.key == "Operating Expenses" || i.key == "Operating Income" || i.key == "Pretax Income" || i.key == "Adjusted EPS (excl. SBC)" || i.key == "GAAP EPS" || i.key == "Net Income") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (835 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (833 * this.value1)).toFixed(2));
          }
        }
        if(this.value2){
          if (i.key == "Gross Profit" || i.key == "Operating Income" || i.key == "Pretax Income" || i.key == "Adjusted EPS (excl. SBC)" || i.key == "GAAP EPS" || i.key == "Net Income") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (835 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (833 * this.value2)).toFixed(2));
          }
        }
        if(this.value3){
          if (i.key == "Operating Expenses" || i.key == "Operating Income" || i.key == "Pretax Income" || i.key == "Net Income") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (835 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (833 * this.value3)).toFixed(2));
          }
        }
        if(this.value4){
          if (i.key == "Operating Expenses" || i.key == "Operating Income" || i.key == "Pretax Income" || i.key == "Adjusted EPS (excl. SBC)" || i.key == "GAAP EPS" || i.key == "Net Income") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (835 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (833 * this.value4)).toFixed(2));
          }
        }
        if(this.value5){
          if (i.key == "Adjusted EPS (excl. SBC)" || i.key == "GAAP EPS" || i.key == "Net Income") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (835 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (833 * this.value5)).toFixed(2));
          }
        }
        this.incomestatementTableDataLocal.push(i)
        this.getcostDriverChartData(this.filterChartTab)
      }
      this.costassumptionsTableDataLocal = []
      for(let [idx,i] of this.formatdata(this.costassumptions, "assumption").entries()){
        if(this.value1){
          if (i.key == "Operating Income" || i.key == "Net Income" || i.key == 'General & Administrative' ) {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.25 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.8 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.8 * this.value1)).toFixed(2));
          }
        }
        if(this.value2){
          if (i.key == "Operating Income" || i.key == "Net Income" || i.key == 'Gross Profit' ) {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.25 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.8 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.8 * this.value2)).toFixed(2));
          }
        }
        if(this.value3){
          if (i.key == "Operating Income" || i.key == "Net Income" || i.key == 'R & D' ) {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.25 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.8 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.8 * this.value3)).toFixed(2));
          }
        }
        if(this.value4){
          if (i.key == "Operating Income" || i.key == "Net Income" || i.key == 'Sales & Marketing' ) {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.25 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.8 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.8 * this.value4)).toFixed(2));
          }
        }
        if(this.value5){
          if (i.key == "Operating Income" || i.key == "Net Income" || i.key == 'Tax Rate' ) {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.25 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.8 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.8 * this.value5)).toFixed(2));
          }
        }
     
        this.costassumptionsTableDataLocal.push(i)
        this.getCostMetricsChartData(this.filterChartTabCA)
      }
    },
    formatdata(mapData, chartKey) {
      let tableData = [];
      if (
        typeof mapData.category != "undefined" &&
        mapData.category.length > 0
      ) {
        for (var i = 0; i < mapData.category.length; i++) {
          tableData.push({ key: mapData.category[i] });
          for (var j = 0; j < mapData.xaxis.length; j++) {
            let cat = mapData.category[i].toLowerCase().replace(/\s/g, "");
            tableData[i][mapData.xaxis[j]] = mapData[cat][j];
          }
        }
      }
      if (tableData.length > 0) {
        if (chartKey == "income" && !this.calcCost) {
          this.calcCost = true;
          this.getcostDriverChartData("Operating Income");
        }

        if ((chartKey == "assumption") & !this.calcAssumption) {
          this.calcAssumption = true;
          this.getCostMetricsChartData("2016A");
        }
      }

      return tableData;
    },
    renderCAsChart(filter,xaxis,yaxis){
      this.costMetricsChartData[0].name = filter;
      this.costMetricsChartData[0].labels = xaxis
      this.costMetricsChartData[0].values = yaxis;
      this.costMetricsChartData[0].marker = {
        colors: this.colorArr,
      };
    },
    getCostMetricsChartData(filter) {
      let self = this
      this.filterChartTabCA = filter
      let costassumptions = JSON.parse(sessionStorage.getItem("costassumptions"));
      setTimeout(function(){
        let xaxis = []
        let yaxis = []
        
        for(let [i,d] of self.costassumptionsTableDataLocal.entries()){
          if(!['Gross Profit','Operating Income'].includes(d.key)){
            xaxis.push(d.key)
            let dd = d[filter];
            if(typeof(d[filter])=='string'){
              dd = d[filter].slice(0,d[filter].length-1)
            }
            yaxis.push(dd)
          }
        }
        // console.log('shakti',filter)
        // console.log('shakti',xaxis)
        // console.log('shakti',yaxis)
        self.renderCAsChart(filter,xaxis,yaxis)
      },100)
    },

    renderIncomeChart(filter,xaxis,yaxis){
        this.costDriverChartData[0].name = filter;
        this.costDriverChartData[0].x = xaxis;
        this.costDriverChartData[0].y = [];
        this.costDriverChartData[0].y = yaxis;
        this.costDriverChartData[1].x = xaxis;
        let yoyData = yaxis;
        this.costDriverChartData[1].y = [];
        for (let i = 0; i < yoyData.length; i++) {
          let yoy = 0;
          if (i > 0) {
            yoy = (
              ((yoyData[i] - yoyData[i - 1]) / yoyData[i - 1]) *
              100
            ).toFixed(1);
          }
          this.costDriverChartData[1].y.push(yoy);
        }
    },


    getcostDriverChartData(filter) {
      let self = this
      this.filterChartTab = filter
      let incomestatementmillions = JSON.parse(sessionStorage.getItem("incomestatementmillions"));
      setTimeout(function(){
        let xaxis = incomestatementmillions.xaxis
        let yaxis = []
        for(let [i,d] of self.incomestatementTableDataLocal.entries()){
          if(filter == d.key  ) {
            for(let [yi,yd] of xaxis.entries()){
              yaxis.push(d[yd])
            }
          } 
        }
        self.renderIncomeChart(filter,xaxis,yaxis)
      },100)
    },
  },
  mounted() {
    this.incomestatementTableDataLocal = this.formatdata(this.incomestatementmillions, "income");
    this.costassumptionsTableDataLocal = this.formatdata(this.costassumptions, "assumption");
    let filterChart = this.iMostChildren.filter(
      (item) => "Cost Drivers" === item.objectname
    );
    // console.log('filterChart-==',filterChart);
    let snapshopChild = filterChart[0].child;
    for (var i = 0; i < snapshopChild.length; i++) {
      this.getChartDataById({
        id: snapshopChild[i].chartId,
        chartName: snapshopChild[i].objectname,
      });
    }

    this.setDownloadInfo({
      fileName: "costdrivers",
      downloadData: this.$refs.capture,
    });
    this.getcostDriverChartData("Operating Income");
    this.getCostMetricsChartData("2016A");
  },
  filters: {
    roundOff(num) {
      return isNaN(num) ? num : num.toFixed(2);
    },
    roundOffPer(num) {
      return isNaN(num) ? num : num + "%";
    },
  },
};
</script>

<style>
.tblWrapper {
  margin-bottom: 12px;
}
.tblWrapper h5 {
  font-size: 1rem;
  padding-top: 10px;
}
.tblWrapper table {
  border: 1px solid;
  position: relative;
  width: 100%;
  font-size: 11px;
  border: none;
}
.tblWrapper table thead {
  width: 100%;
  background: #fff;
  color: #333;
  text-align: left;
  font-size: 11px;
}
.costdriversPanel {
  max-height: 45vh;
  overflow: auto;
}
.costdriversPanel .card-header {
  padding: 0rem 0.2rem;
  font-size: 0.9rem;
}
.rightAligned {
  text-align: right;
}
.costdriversPanel .card-body {
  padding: 0.25rem;
}
.costdriversHeader .exportDropDown .btn,
.costdriversHeader .fullscreenBtn {
  padding: 0 5px;
}
.costdriversPanel .filterBtn .btn {
  margin-right: 5px;
  padding: 0.2rem 0.5rem !important;
  font-size: 0.9rem;
}
.costdriversPanel .filterBtn {
  margin: 0 auto;
}
</style>
